import { render, staticRenderFns } from "./PickupAndWeighForm.vue?vue&type=template&id=46ca111c&"
import script from "./PickupAndWeighForm.vue?vue&type=script&lang=js&"
export * from "./PickupAndWeighForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports